// @flow

import React from 'react';
import styled from 'styled-components';
import type { Theme } from '../../../types';

const CloseIcon = () => (
  <Icon className="icon-cross" />
);

const Icon = styled<any, Theme>('i')`
  margin-left: 0.5rem;
  font-size: .8rem;
  line-height: 0;
  &:before {
    vertical-align: middle;
  }
`;

export default CloseIcon;
